module.exports = __webpack_public_path__ + "img/PRIVATE-OCCASIONS.cdd0cf91.jpg";